var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "app-switcher" } }, [
    _c(
      "div",
      {
        ref: "appSwitcher",
        staticClass: "app-switcher-overlay",
        class: { "has-custom-apps": _vm.appSwitcherWebTabs.length > 0 },
      },
      [
        _c("div", { staticClass: "app-switcher-main" }, [
          _c(
            "div",
            { staticClass: "app-switcher-content" },
            [
              _vm._l(_vm.apps, function (app) {
                return _c("div", { key: app.appKey, staticClass: "app-box" }, [
                  _c(
                    "a",
                    {
                      staticClass: "app-link",
                      attrs: { href: _vm.getAppHref(app) },
                      on: {
                        click: function ($event) {
                          return _vm.handleAppClick(app, $event)
                        },
                      },
                    },
                    [
                      app.antIcon
                        ? _c("a-icon", {
                            class: ["app-icon", { "is-ant-icon": app.antIcon }],
                            attrs: { type: app.antIcon },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      app.materialIcon
                        ? _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              class: [
                                "app-icon",
                                { "is-material-icon": app.materialIcon },
                              ],
                            },
                            [_vm._v(_vm._s(app.materialIcon))]
                          )
                        : _c(_vm.getIcon(app), {
                            tag: "component",
                            staticClass: "custom-app-icon",
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "app-name" }, [
                        _vm._v(_vm._s(app.title)),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
              _vm._v(" "),
              _vm.appSwitcherWebTabs.length === 0
                ? _c(
                    "div",
                    {
                      staticClass: "app-box add-app-box",
                      on: { click: _vm.goToWebApps },
                    },
                    [
                      _c("div", { staticClass: "app-link" }, [
                        _c(
                          "span",
                          { staticClass: "material-icons app-icon add-icon" },
                          [_vm._v("add_circle_outline")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "app-name" }, [
                          _vm._v("Yeni Uygulama"),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.appSwitcherWebTabs.length > 0
            ? _c("div", { staticClass: "custom-apps-section" }, [
                _c("div", { staticClass: "custom-apps-header" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("extension"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Özel Uygulamalar")]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "custom-apps-grid" },
                  [
                    _vm._l(_vm.appSwitcherWebTabs, function (webTab) {
                      return _c(
                        "div",
                        {
                          key: webTab._id,
                          staticClass: "app-box",
                          on: {
                            click: function ($event) {
                              return _vm.handleWebTabClick(webTab, $event)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "app-link" }, [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons app-icon",
                                style: { color: webTab.iconColor || "#C9BBF6" },
                              },
                              [_vm._v(_vm._s(webTab.icon))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "app-name" }, [
                              _vm._v(_vm._s(webTab.name)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "app-box add-app-box",
                        on: { click: _vm.goToWebApps },
                      },
                      [
                        _c("div", { staticClass: "app-link" }, [
                          _c(
                            "span",
                            { staticClass: "material-icons app-icon add-icon" },
                            [_vm._v("add_circle_outline")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "app-name" }, [
                            _vm._v("Yeni Uygulama"),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }